module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chip-group"
  }, _vm._l((_vm.items), function(item) {
    return _c('AppChip', {
      key: item.id,
      attrs: {
        "item": item,
        "is-active": _vm.selectedIds.includes(item.id)
      },
      on: {
        "toggle": _vm.toggleItem
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0392bac","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppChipGroup/AppChipGroup.vue
// module id = cb900b1ac6c4e55b848f
// module chunks = 12